export default __webpack_public_path__ + "static/media/port6.78845a5f.jpg";